import React from 'react';
import {Container} from 'react-bootstrap';
import {translate} from 'react-switch-lang';
import PropTypes from 'prop-types';
import TourOfTheMonthCard from '../components/tourOfTheMonth';
import GMap from '../components/gmap';
import DocumentMeta from 'react-document-meta';
import {isEnglishSet, metaTagsCZ, metaTagsEN} from '../shared/utils';

class TourOfTheMonth extends React.Component {
  render() {
    const {t} = this.props;
    const metaTags = isEnglishSet() ? metaTagsEN.tourOfTheMonth : metaTagsCZ.tourOfTheMonth;
    window.scrollTo(0, 0);
    return (
      <DocumentMeta {...metaTags}>
        <Container className="mt-5 mb-5 pt-5 pb-5">
          <h3>{t('pages.tourOfTheMonth.title')}</h3>
          {t('pages.tourOfTheMonth.legend')}
          <br />
          <br />
          {t('pages.tourOfTheMonth.note2')}
          <br />
          <br />
          {t('pages.tourOfTheMonth.note3')}
          <TourOfTheMonthCard showLink={false} />
          <GMap type="NY" />
        </Container>
      </DocumentMeta>
    );
  }
}

TourOfTheMonth.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(TourOfTheMonth);
